import React from 'react';
import './Mission.css';
import { FaBullseye, FaRocket } from 'react-icons/fa';

const Mission = () => {
  
  return (
    <div className="vm-section py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="vm-box vision-box">
              <div className="row align-items-start">
                <div className="col-lg-3 col-md-3 m-auto text-center">
                  <FaBullseye className="vm-icon" />
                </div>
                <div className="col-lg-9 col-md-9">
                  <h4 className="vm-title">Vision</h4>
                  <p className="vm-text">
                    This slide is an editable slide with all your needs. Adapt it with your needs and it will capture all the
                    audience attention. Capture your audience attention. Download this awesome creatives and bring your
                    presentation to life, with our creativity.
                  </p>
                </div>
              </div>
            </div>
          </div>
           <div className="col-lg-4"></div>
        </div>

        <div className="row">
          <div className="col-lg-4"></div>
          <div className="col-lg-8">
            <div className="vm-box mission-box">
              <div className="row align-items-start flex-row-reverse">
                <div className="col-lg-3 col-md-3 m-auto text-center">
                  <FaRocket className="vm-icon" />
                </div>
                <div className="col-lg-9 col-md-9">
                  <h4 className="vm-title1">Mission</h4>
                  <p className="vm-text1">
                    This slide is an editable slide with all your needs. Adapt it with your needs and it will capture all the
                    audience attention. Capture your audience attention. Download this awesome creatives and bring your
                    presentation to life, with our creativity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
